// extracted by mini-css-extract-plugin
export default {"root":"RMUi2"};